module.exports = __webpack_public_path__ + "img/材料力学1_6_2.e4321a5a.jpg";